import { useQuery } from "@tanstack/react-query";
import { getSalesOffices } from "../services/salesOfficeService";

const useSalesOffices = () => useQuery({
    queryKey: ['salesOffices'],
    queryFn: () => getSalesOffices().then(res => res.data),
    staleTime: 7 * 24 * 60 * 60 * 1000 // 1 week
});

export default useSalesOffices;